module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C373"
  }, [_c('strong', [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }, [_vm._v("CONTENTS")])])]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('p', {
    staticClass: "C410"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }, [_c('strong')]), _c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/08_INTRODUCTION#page_1"
    }
  }, [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "C411"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_1___The_Gulf_and_Fishing#page_9"
    }
  }, [_c('strong', [_vm._v("1.")]), _vm._v(" The Gulf and Fishing")])]), _vm._v(" "), _c('p', {
    staticClass: "C410"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_FISH#page_19"
    }
  }, [_c('strong', [_vm._v("FISH")])])]), _vm._v(" "), _c('p', {
    staticClass: "C410"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_2___Inshore_Mixed_Bag#page_20"
    }
  }, [_c('strong', [_vm._v("2.")]), _vm._v(" Inshore Mixed Bag")])]), _vm._v(" "), _c('p', {
    staticClass: "C410"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_3___Croakers__Sciaenidae__and_Gr#page_39",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("3.")]), _vm._v(" Croakers (Sciaenidae) and Grunts (Haemulidae)")])]), _vm._v(" "), _c('p', {
    staticClass: "C410"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_4___Jacks__Carangidae#page_49",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("4.")]), _vm._v(" Jacks (Carangidae)")])]), _vm._v(" "), _c('p', {
    staticClass: "C410"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_5___Great_and_Small_Pelagic_Fish#page_58",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("5.")]), _vm._v(" Great and Small Pelagic Fish: Tunas and Mackerels (Scombridae) and Herrings (Clupeidae)")])]), _vm._v(" "), _c('p', {
    staticClass: "C410"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_6___Snappers__Lutjanidae#page_71",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("6.")]), _vm._v(" Snappers (Lutjanidae)")])]), _vm._v(" "), _c('p', {
    staticClass: "C410"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_7___Groupers_and_Seabass__Serran#page_81",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("7.")]), _vm._v(" Groupers and Seabass (Serranidae)")])]), _vm._v(" "), _c('p', {
    staticClass: "C410"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_8___Offshore_Reef__Rubble__and_R#page_92",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("8.")]), _vm._v(" Offshore Reef, Rubble, and Rock Fish")])]), _vm._v(" "), _c('p', {
    staticClass: "C410"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_9___Deepwater_Groundfish#page_112",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("9.")]), _vm._v(" Deepwater Groundfish")])]), _vm._v(" "), _c('p', {
    staticClass: "C410"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_10___Assorted_Blue_Water_Pelagic#page_120",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("10.")]), _vm._v(" Assorted Blue-Water Pelagic Fish")])]), _vm._v(" "), _c('p', {
    staticClass: "C410"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_11___On_the_Subject_of_Gulf_Mari#page_130",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("11.")]), _vm._v(" On the Subject of Gulf Marine Eels")])]), _vm._v(" "), _c('p', {
    staticClass: "C411"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_12___Rays__Skates__and_Sharks__E#page_132",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("12.")]), _vm._v(" Rays, Skates, and Sharks (Elasmobranchs)")])]), _vm._v(" "), _c('p', {
    staticClass: "C410"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_INVERTEBRATES#page_145",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("INVERTEBRATES")])])]), _vm._v(" "), _c('p', {
    staticClass: "C410"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_13___Bivalves__Gastropods__Cepha#page_146",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("13.")]), _vm._v(" Bivalves, Gastropods, Cephalopods, and Oddball Invertebrates")])]), _vm._v(" "), _c('p', {
    staticClass: "C410"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_14___Shrimp__Crabs__and_Other_Cr#page_171",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("14.")]), _vm._v(" Shrimp, Crabs, and Other Crustaceans")])]), _vm._v(" "), _c('p', {
    staticClass: "C410"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_15___A_Few_Words_about_Edible_Pl#page_182",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("15.")]), _vm._v(" A Few Words about Edible Plants Found Close to the Water’s Edge")])]), _vm._v(" "), _c('p', {
    staticClass: "C411"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_16___Some_Honorary_Freshwater_In#page_184",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("16.")]), _vm._v(" Some Honorary Freshwater Inclusions")])]), _vm._v(" "), _c('p', {
    staticClass: "C410"
  }, [_c('strong', [_c('span', {
    attrs: {
      "href": "#/xhtml/27_NUTS_AND_BOLTS#page_188",
      "id": "page_vii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NUTS AND BOLTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "C410"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_17___Finding__Buying__and_Proces#page_189",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("17.")]), _vm._v(" Finding, Buying, and Processing Seafood")])]), _vm._v(" "), _c('p', {
    staticClass: "C410"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_18___The_ABCs#page_194",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("18.")]), _vm._v(" The ABCs")])]), _vm._v(" "), _c('p', {
    staticClass: "C410"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_19___Buying_and_Storing_Seafood#page_203",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("19.")]), _vm._v(" Buying and Storing Seafood")])]), _vm._v(" "), _c('p', {
    staticClass: "C411"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_20___Cutting_Fish__Shucking_Oyst#page_213",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("20.")]), _vm._v(" Cutting Fish, Shucking Oysters, and Cleaning Crabs")])]), _vm._v(" "), _c('p', {
    staticClass: "C410"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_RECIPES#page_222",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("RECIPES")])])]), _vm._v(" "), _c('p', {
    staticClass: "C410"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_21___Whole_Fish#page_223",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("21.")]), _vm._v(" Whole Fish")])]), _vm._v(" "), _c('p', {
    staticClass: "C410"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34_22___Cut_Fish#page_235",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("22.")]), _vm._v(" Cut Fish")])]), _vm._v(" "), _c('p', {
    staticClass: "C410"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_23___Crustaceans#page_250",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("23.")]), _vm._v(" Crustaceans")])]), _vm._v(" "), _c('p', {
    staticClass: "C410"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36_24___Bivalves__Gastropods__and_C#page_255",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("24.")]), _vm._v(" Bivalves, Gastropods, and Cephalopods")])]), _vm._v(" "), _c('p', {
    staticClass: "C410"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/37_25___Preserving_the_Catch#page_263",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("25.")]), _vm._v(" Preserving the Catch")])]), _vm._v(" "), _c('p', {
    staticClass: "C411"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/38_26___Bits_and_Pieces#page_274",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("26.")]), _vm._v(" Bits and Pieces")])]), _vm._v(" "), _c('p', {
    staticClass: "C410"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_ACKNOWLEDGMENTS#page_280",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "C410"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/40_APPENDIX_I__COMMON_SEAFOOD_HAZAR#page_281",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX I. COMMON SEAFOOD HAZARDS")])]), _vm._v(" "), _c('p', {
    staticClass: "C410"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_APPENDIX_II__SPECIES_NOT_DESCRIB#page_284",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX II. SPECIES NOT DESCRIBED BUT OF INTEREST")])]), _vm._v(" "), _c('p', {
    staticClass: "C410"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/42_FURTHER_READING#page_286",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FURTHER READING")])]), _vm._v(" "), _c('p', {
    staticClass: "C410"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/43_RECIPE_INDEX#page_289",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RECIPE INDEX")])]), _vm._v(" "), _c('p', {
    staticClass: "C410"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/44_GENERAL_INDEX#page_295",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GENERAL INDEX")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79a86765","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Contents.vue
// module id = 72
// module chunks = 0